var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.018 30c7.743 0 14.019-6.268 14.019-14S23.76 2 16.018 2C8.276 2 2 8.268 2 16s6.276 14 14.018 14zM13.545 8.588h4.947v4.993h-4.947v4.839h4.947v4.992h-4.948v-4.838H8.597v-4.993h4.948V8.59zm4.948 4.993h4.948v4.994h-4.947v-4.993z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClv);
export default __webpack_public_path__ + "static/media/CLV.10d2350c5bdbc558e07adbf644523926.svg";
export { ForwardRef as ReactComponent };